function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function onFormSubmit() {
  var msg = $("#form-message");
  var email = $("#email-input").val();

  if (validateEmail(email)) {
    var form = $("#email-subscribe-form");
    msg.html("&nbsp");
    jQuery.post(form.attr("action"), form.serialize()).then(function() {
      msg.text("Thank you! We'll be in touch.");
    }).catch(function() {
      msg.text("Error subscribing :( Please try again later.");
    });
  } else {
    msg.text("Please enter a valid email address.");
  }
  return false;
}

$(document).ready(function() {
  $("#subscribe-button").bind("click", onFormSubmit);
});
